function validatePresence(value) {
  if (typeof value === 'string') return value.trim().length > 0

  return value != null
}

export default validatePresence
